<template>
  <!-- Swiper -->
  <div v-if="isMounted" class="swiper mySwiper">
    <div :class="['swiper-wrapper',{'transition-timing': options.isTransform}]">
      <div class="swiper-slide" v-for="(item,index) in list">
        <!--        <img :src="item.图片地址" alt="">-->
        <slot name="menu" :row="item" :index="index" @click="$emit('click')"></slot>
      </div>
    </div>
    <div class="swiper-button-next" v-show="isButton"></div>
    <div class="swiper-button-prev" v-show="isButton"></div>
    <div class="swiper-pagination" v-show="isPagination"></div>
    <!--    <div class="swiper-scrollbar"></div>-->
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isButton: {
      type: Boolean,
      default: false
    },
    isPagination: {
      type: Boolean,
      default: false
    },
  },
  mixins: [],
  data() {
    return {
      mySwiper: null,
      isMounted: false
    };
  },
  computed: {},
  watch: {
    options: {
      handler(newValue, oldValue) {
        console.log('newValue, oldValue', newValue, oldValue)
        this.$nextTick(() => {
          this.init()
        })
      },
      deep: true
    },
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.isMounted = true;
      this.$nextTick(() => {
        this.init();
      });
    });
  }
  ,
  methods: {
    init() {
      let autoPlay;
      if (this.options.autoplay) {
        autoPlay = {
          delay: this.options.delay,
        }
      } else {
        autoPlay = false
      }

      let options = {
        speed: this.options.speed,
        autoplay: autoPlay,
        loop: this.options.loop,
        freeMode: this.options.freeMode,
        allowTouchMove: this.options.allowTouchMove,
        cssMode: this.options.cssMode,
        slidesPerView: this.options.slidesPerView,
        spaceBetween: this.options.spaceBetween,
        observer: true,
        observeParents: true,
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 如果需要滚动条
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      }
      console.log('options', options)
      this.mySwiper = new Swiper(this.$el, options)
    }
  },
  beforeDestroy() {
  },
  destroyed() {
  },
}

</script>

<style scoped lang="scss">

.swiper {
  width: 100%;
  height: 300px;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    flex: 1;
  }
}

.swiper-wrapper {
  will-change: transform;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  transition-timing-function: ease-out;
}

.transition-timing {
  transition-timing-function: linear !important; /* 保持匀速 */
}
</style>

